import React, { PureComponent } from 'react';
import cn from 'classnames';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
import { number, string, array, bool, node, object, func, oneOfType } from 'prop-types';
import Card from './Card';

class CardWithTabs extends PureComponent {
  static propTypes = {
    title: oneOfType([string, node]),
    navs: array.isRequired,
    tabs: array.isRequired,
    actions: array,
    activeTab: number,
    loading: bool,
    noPadding: bool,
    withDropdown: bool,
    right: bool,
    innerRef: oneOfType([object, func, string]),
  };

  static defaultProps = {
    tabs: [],
    navs: [],
    actions: [],
    loading: false,
    activeTab: 1,
    withDropdown: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      activeTab: props.activeTab,
      dropdownOpen: false,
    };
  }

  toggleTab = tab => {
    this.state.activeTab !== tab && this.setState(() => ({ activeTab: tab }));
  };

  renderDropdown = (navs = []) => {
    const { activeTab } = this.state;
    const { right } = this.props;

    return (
      <Dropdown
        className="dropdown-navigation"
        isOpen={this.state.dropdownOpen}
        toggle={this.toggleDropdown}
      >
        <DropdownToggle color="blue-light" caret>
          {navs[activeTab - 1]}
        </DropdownToggle>

        <DropdownMenu right={right}>
          {navs.map((nav, i) => (
            <DropdownItem key={i} tag="div" className="no-padding">
              <NavLink
                className={cn({ active: activeTab === i + 1 })}
                onClick={() => {
                  this.toggleTab(i + 1);
                }}
              >
                {nav}
              </NavLink>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    );
  };

  renderBtns = btnItems => {
    const { showAlert, btnProps } = this.props;
    return (
      <div className="nav-btns">
        {btnItems.map((BtnItem, index) => (
          <BtnItem key={index} showAlert={showAlert} {...btnProps} />
        ))}
      </div>
    );
  };

  toggleDropdown = () => {
    this.setState(prevState => ({ dropdownOpen: !prevState.dropdownOpen }));
  };

  render() {
    const { activeTab } = this.state;

    const {
      title,
      tabs,
      loading,
      navs,
      actions,
      innerRef,
      className,
      noPadding,
      withDropdown,
      children,
      btnItems,
    } = this.props;

    return (
      <Card
        className={cn(className, { 'card-with-dropdown': withDropdown })}
        loading={loading}
      >
        <Card.Header innerRef={innerRef}>
          {title && <div className="card-title">{title}</div>}

          <div className="card-controls">
            {navs.length > 0 && (
              <div className="tab-controls">
                <Nav tabs>
                  {navs.map((nav, index) => (
                    <NavItem key={nav.props.id}>
                      <NavLink
                        className={cn({ active: activeTab === index + 1 })}
                        onClick={() => {
                          this.toggleTab(index + 1);
                        }}
                      >
                        {nav}
                      </NavLink>
                    </NavItem>
                  ))}
                </Nav>
              </div>
            )}

            {withDropdown && this.renderDropdown(navs)}
          </div>

          {actions.length > 0 && (
            <div className="action-controls">
              <div className="navigation-links">
                <Nav pills>
                  {actions.map((action, index) => (
                    <NavItem key={index}>{action}</NavItem>
                  ))}
                </Nav>
              </div>
            </div>
          )}
          {btnItems && btnItems.length ? this.renderBtns(btnItems) : null}
        </Card.Header>

        {tabs.length > 0 && (
          <Card.Body className={cn({ 'no-padding': noPadding })}>
            <TabContent activeTab={activeTab}>
              {tabs.map((tab, index) => (
                <TabPane key={index} tabId={index + 1}>
                  {tab}
                </TabPane>
              ))}
            </TabContent>
          </Card.Body>
        )}

        {children}
      </Card>
    );
  }
}

export default CardWithTabs;
